import { DeliveryStatusEnum, DeliveryTypeEnum } from '@onArte/shared/database/enums';
import { AddressInterface, OrderCostInfoDTO } from '@onArte/shared/interfaces/common';

import { OrderAuctionInfoDTO } from './orderAuctionInfo.dto';

export class OrderAuctionDetailsDTO {
  constructor(
    public auction: OrderAuctionInfoDTO,
    public deliveryType: DeliveryTypeEnum,
    public costs: OrderCostInfoDTO[],
    public deliveryAddress: AddressInterface | null,
    public billingAddress: AddressInterface | null,
    public pickupAddress: AddressInterface | null,
    public invoiceRequired: boolean | null,
    public commentToSeller: string | null,
    public trackingCode: string | null,
    public trackingUrl: string | null,
    public delivered: boolean | null,
    public deliveryStatus: DeliveryStatusEnum | null,
    public sellerEmail: string | null,
  ) {}
}
